import styles from './SucculentCard.module.css';

export interface SucculentCardProps {
  plant: {
    plant_name: string;
    show_image_url: string | null;
    variety?: string | null;
  };
  variant: 'public' | 'mine';
  layout?: 'grid' | 'list';
  onClick?: () => void;
}

/**
 * 多肉植物卡片，参考截图样式
 */
export const SucculentCard: React.FC<SucculentCardProps> = ({ plant, variant, layout = 'grid', onClick }) => {
  const isMine = variant === 'mine';

  if (layout === 'list') {
    return (
      <div className={styles.listCard} onClick={onClick}>
        <div className={styles.listImageWrapper}>
          {plant.show_image_url ? (
            <img src={plant.show_image_url} alt={plant.plant_name} />
          ) : (
            <div className={styles.placeholder}>暂无图片</div>
          )}
        </div>
        <div className={styles.listInfo}>
          <span className={styles.listName}>{plant.plant_name}</span>
          <span className={styles.listArrow}>&rsaquo;</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.imageWrapper}>
        {plant.show_image_url ? (
          <img src={plant.show_image_url} alt={plant.plant_name} />
        ) : (
          <div className={styles.placeholder}>暂无图片</div>
        )}
      </div>
      {isMine && (
        <div className={styles.info}>
          <span className={styles.name}>{plant.plant_name}</span>
        </div>
      )}
    </div>
  );
};
